import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import {
  TABLE_CELL_BORDER_RIGHT_WIDTH,
  TABLE_CELL_PADDING_X,
} from 'components/Table/tableSettings';

export const getCellWidthAndPaddingStyle =
  (paddingX?: number, borderRightWidth = TABLE_CELL_BORDER_RIGHT_WIDTH) =>
  (
    columnWidth: number,
  ): {
    width: number;
    paddingLeft: number;
    paddingRight: number;
  } => {
    const halfPaddingBoxWith = (columnWidth - borderRightWidth) / 2;
    if (halfPaddingBoxWith < 0) {
      stumble(
        'cell cannot have less than its border size, render glitches will occur',
      );
    }
    return {
      width: columnWidth,
      paddingLeft: Math.min(
        Math.floor(halfPaddingBoxWith),
        paddingX ?? TABLE_CELL_PADDING_X,
      ),
      paddingRight: Math.min(
        Math.ceil(halfPaddingBoxWith),
        paddingX ?? TABLE_CELL_PADDING_X,
      ),
    };
  };
